/* eslint-disable react/prop-types */
import React from 'react';
import {
  Col,
  Form,
  Input,
  Row,
} from 'antd';

const ExpedienteDatosPersonales = ({
  form,
// eslint-disable-next-line arrow-body-style
}) => {
  return (
    <Form
      layout="vertical"
      form={form}
      scrollToFirstError
      name="general"
      disabled
    >
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="genero"
            label="Género"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="estado_civil"
            label="Estado Civil"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="domicilio"
            label="Domicilio"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="telefono"
            label="Teléfono"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="rfc"
            label="RFC"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="curp"
            label="CURP"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="no_seguridad_social"
            label="No. de Seguridad Social"
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="estado_del_empleado"
            label="Estatus"
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default ExpedienteDatosPersonales;
